export default __webpack_public_path__ + "static/logo-krystufek-4a875df9a2b6a7db99f1aaf42001bed7.svg";